import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const ChartLine = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="ChartLine" {...props}>
    <path d="M22 21C22.5523 21 23 21.4477 23 22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22C1 21.4477 1.44772 21 2 21H22Z" fill="#000" /><path d="M23 9C23 9.55228 22.5523 10 22 10C21.4477 10 21 9.55228 21 9V5.5L14.1387 12.3623L10.6172 9.34277L2.77148 16.7285C2.36931 17.107 1.73592 17.0877 1.35742 16.6855C0.978964 16.2834 0.998237 15.65 1.40039 15.2715L10.5547 6.65625L14.0332 9.6377L19.6719 4H16C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2H23V9Z" fill="#000" />
  </StyledIcon>
));

ChartLine.displayName = 'ChartLine';

export { ChartLine };
